import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SubscriptionsAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SubscriptionsAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M21 11.75C21.2761 11.75 21.5 11.9739 21.5 12.25C21.4999 15.2875 19.0375 17.75 16 17.75H11.3809L13.3203 19.3663C13.5321 19.5431 13.5605 19.8583 13.3838 20.0704C13.207 20.2821 12.8917 20.3104 12.6797 20.1338L9.21875 17.25L12.6797 14.3663C12.8917 14.1895 13.207 14.2179 13.3838 14.4297C13.5604 14.6418 13.5321 14.957 13.3203 15.1338L11.3809 16.75H16C18.4852 16.75 20.4999 14.7352 20.5 12.25C20.5 11.9739 20.7239 11.75 21 11.75Z"
        fill="#503291"
      />
      <path
        d="M10.6162 3.92973C10.793 3.71785 11.1083 3.68955 11.3203 3.86625L14.7812 6.75004L11.3203 9.63383C11.1083 9.8104 10.793 9.78209 10.6162 9.57035C10.4395 9.35834 10.4679 9.04309 10.6797 8.86625L12.6191 7.25004H8C5.51472 7.25004 3.5 9.26476 3.5 11.75C3.49989 12.0261 3.27607 12.25 3 12.25C2.72393 12.25 2.50011 12.0261 2.5 11.75C2.5 8.71247 4.96243 6.25004 8 6.25004H12.6191L10.6797 4.63383C10.4679 4.45703 10.4396 4.14177 10.6162 3.92973Z"
        fill="#503291"
      />
    </Icon>
  )
}
export default SubscriptionsAccountIcon
